/**
 * Add `tatHours` to `startDateStr`.
 *
 * When `mode` is 'business' (default) hours only count during working
 * windows (as declared by the loaded calendar); 'calendar' hours run
 * straight through (used for waits that don't care about our office
 * hours, e.g. waiting on the client).
 *
 * Passing a hydrated `Cal` (from ./workingTime) enables full
 * calendar-aware maths: holidays, custom day windows, lunch breaks,
 * anything the office edits under Super Admin.  If nothing is passed
 * the function falls back to the seeded defaults (Mon–Sat 09–18, lunch
 * 13:30–14:00, Sunday off) so components can still render before the
 * calendar API responds.
 */
import { hydrate, addWorkingHours as addBiz, type CalendarPayload } from './workingTime';

export function calculateDueDate(
  startDateStr: string | null | undefined,
  tatHours: number,
  mode: 'business' | 'calendar' = 'business',
  calendar?: CalendarPayload,
): Date | null {
  if (!startDateStr) return null;
  const start = new Date(startDateStr);
  if (isNaN(start.getTime())) return null;

  if (mode === 'calendar') {
    return new Date(start.getTime() + tatHours * 60 * 60 * 1000);
  }

  return addBiz(hydrate(calendar), start, tatHours);
}
